var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion__list"},_vm._l((JSON.parse(_vm.accordions)),function(accordion,index){return _c('div',{key:index,staticClass:"accordion__list__items"},[_c('accordion-list-item',{attrs:{"title":accordion.title,"text":accordion.text}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib?{}!./scripts/vue/AccordionList.vue?vue&type=template&id=56097b47&scoped=true&
// module id = 423
// module chunks = 0